/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Auto-generated SVG asset */
import type { SVGProps } from 'react';
import * as React from 'react';

import { token } from '@atlaskit/tokens';
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={260}
		height={140}
		viewBox="0 0 260 140"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g>
			<path
				d="M0 24a8 8 0 0 1 8-8h233a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
				fill={token('elevation.surface')}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.847 32.471a6.63 6.63 0 0 0 6.635 6.625 6.6 6.6 0 0 0 3.24-.842l3.905 3.899 2.526-2.522-3.898-3.892c.549-.964.862-2.08.862-3.268 0-3.658-2.97-6.624-6.635-6.624s-6.635 2.966-6.635 6.624m2.552 0a4.08 4.08 0 0 0 4.083 4.077 4.08 4.08 0 0 0 4.083-4.077 4.08 4.08 0 0 0-4.083-4.076 4.08 4.08 0 0 0-4.083 4.076"
				fill={token('color.icon')}
			/>
			<path fill={token('color.background.accent.gray.subtlest')} d="M44 30h193v8H44z" />
			<path d="M44 68a8 8 0 0 1 8-8h352a8 8 0 0 1 8 8v32H44z" fill={token('elevation.surface')} />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M66 74.685a7.5 7.5 0 0 0-2.37 14.617c.374.069.511-.163.511-.362 0-.178-.006-.65-.01-1.275-2.087.453-2.527-1.006-2.527-1.006-.34-.866-.833-1.097-.833-1.097-.68-.465.052-.456.052-.456.753.053 1.149.773 1.149.773.669 1.146 1.755.815 2.183.623.068-.484.262-.815.476-1.002-1.666-.19-3.417-.833-3.417-3.707 0-.82.293-1.488.773-2.013-.078-.19-.335-.952.073-1.985 0 0 .63-.201 2.063.769A7.2 7.2 0 0 1 66 78.312a7.2 7.2 0 0 1 1.878.252c1.432-.97 2.06-.769 2.06-.769.41 1.033.152 1.796.075 1.985.48.525.77 1.194.77 2.013 0 2.881-1.753 3.515-3.423 3.7.269.232.508.69.508 1.39 0 1.002-.009 1.811-.009 2.057 0 .2.136.434.516.361a7.5 7.5 0 0 0-2.376-14.616"
				fill={token('color.icon')}
			/>
			<path
				fill={token('color.background.accent.gray.subtlest')}
				d="M88 72h246v8H88zm0 12h161v8H88z"
			/>
			<path fill={token('elevation.surface')} d="M44 100h368v36H44z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M66 110.685a7.5 7.5 0 0 0-2.37 14.617c.374.069.511-.163.511-.362 0-.178-.006-.65-.01-1.275-2.087.453-2.527-1.006-2.527-1.006-.34-.866-.833-1.097-.833-1.097-.68-.465.052-.456.052-.456.753.053 1.149.773 1.149.773.669 1.146 1.755.815 2.183.623.068-.484.262-.815.476-1.002-1.666-.19-3.417-.833-3.417-3.707a2.9 2.9 0 0 1 .773-2.013c-.078-.189-.335-.952.073-1.985 0 0 .63-.201 2.063.769a7.2 7.2 0 0 1 1.877-.252 7.2 7.2 0 0 1 1.878.252c1.432-.97 2.06-.769 2.06-.769.41 1.033.152 1.796.075 1.985.48.525.77 1.194.77 2.013 0 2.881-1.753 3.515-3.423 3.701.269.231.508.689.508 1.389 0 1.002-.009 1.811-.009 2.057 0 .201.136.434.516.361a7.5 7.5 0 0 0-2.376-14.616"
				fill={token('color.icon')}
			/>
			<path
				fill={token('color.background.accent.gray.subtlest')}
				d="M88 108h316v8H88zm0 12h182v8H88z"
			/>
			<path fill={token('elevation.surface')} d="M44 136h368v36H44z" />
			<g fill={token('color.icon')}>
				<path d="M31.718 86.83c-.398.398-1.393-.224-1.214-.751.262-.75.611-1.482 1.15-2.368.672-.975 1.037-1.09 1.434-1.778.72-1.146 1.644-3.244 1.864-3.757.038-.076.07-.144.124-.21.046-.07.038 0 .102-.059.012-.018.026-.02.029-.044 0 0-.012-.02-.015-.035l-.018-.012-.186-.12a36 36 0 0 0-2.135-1.1 338 338 0 0 0-2.67-1.384c-1.04-.551-1.776-1.068-2.446-1.667-.367-.328.104-1.245.586-1.133.876.204 1.718.5 2.77 1.034.405.212 1.392.4 2.615.982q.306.142.559.364c.488.393 1.058.776 1.592 1.099l.195.127c.118.051.216.115.319.17.224.12.44.235.64.353.413.218.782.407 1.092.571-.461.747-.715 1.175-.715 1.175l-2.955 4.736c-.617.987-.914 1.462-1.098 1.746-.556.874-1.062 1.516-1.625 2.07z" />
				<path d="M17.512 47.468c1.276-.721 1.848.32.834 1.16-1.409 1.254-2.783 2.668-4.14 4.773-.773 1.188-1.204 1.967-1.545 2.665a9.6 9.6 0 0 0-.834 2.27c-.402 1.606-.485 3.847-.176 5.776.128.967.413 1.846.617 2.56.278.697.492 1.24.616 1.535.09.172.174.353.249.528.236.645.994 2.387 2.504 4.215.726.939 1.707 1.816 2.765 2.632 1.088.77 2.278 1.481 3.526 1.928.852.377 1.672.57 2.404.782.75.147 1.411.275 2.001.356 1.19.13 2.072.112 2.67.085 2.84-.158 4.92-.759 6.92-1.526 1.075-.449 1.647.416.59 1.129-1.924 1.232-4.215 2.175-7.406 2.37-1.205.048-3.893.418-7.431-.812-.56-.226-1.136-.425-1.642-.753-2.254-1.265-4.51-3.187-5.946-4.954-.38-.424-.698-.846-.958-1.242-.26-.395-.533-.712-.692-1.03a68 68 0 0 0-.562-.958s-.074-.137-.21-.376c-.113-.251-.276-.622-.477-1.068-.412-.899-.84-2.199-1.14-3.656-.658-2.925-.31-6.483.277-8.471.855-3 1.756-4.269 2.217-5.054 1.528-2.348 3.23-3.801 4.969-4.864" />
			</g>
		</g>
	</svg>
);

export { SVGComponent as DynamicConnectorIllustration };
